import React, { useCallback, useEffect, useState } from 'react';
import { IconStarredFolder } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import usePresetShortcuts from 'packages/hooks/shortcuts/usePresetShortcut';
import { parseShortcutForTooltip } from 'packages/common/WithShortcutLabel';
import { useComponentsContext } from 'packages/common/Components/ComponentsContext';
import generateTestId from '~/helpers/testIdHelpers';
import useEditor from '../../../../../hooks/useEditor';
import { collectTopLevelElements } from './utils';
import { TimelineActionsIcon } from '../TimelineActions.styled';

export default function PresetAction() {
    const { translate } = useTranslate();
    const { manipulationRenderer } = useEditor();
    const [selectedElements, setSelectedElements] = useState(() =>
        collectTopLevelElements(manipulationRenderer?.getSelectedElements() || []),
    );
    const isActive = selectedElements.length > 0;

    const { openComponentModal } = useComponentsContext();

    const handleCreatePreset = useCallback(() => {
        if (!selectedElements.length) {
            return;
        }

        openComponentModal('create', selectedElements);
    }, [openComponentModal, selectedElements]);

    useEffect(() => {
        if (!manipulationRenderer) {
            return;
        }

        const listener = () => {
            setSelectedElements(collectTopLevelElements(manipulationRenderer.getSelectedElements()));
        };

        manipulationRenderer.eventEmitter.on('elementSelected', listener);

        return () => {
            manipulationRenderer.eventEmitter.off('elementSelected', listener);
        };
    }, [manipulationRenderer]);

    usePresetShortcuts({ createPreset: handleCreatePreset });

    return (
        <div
            title={`${translate('editor.timeline.element.component.save')} (${parseShortcutForTooltip(['cmd', 'p'])})`}
        >
            <TimelineActionsIcon
                onClick={handleCreatePreset}
                active={isActive}
                {...generateTestId('timeline_actions_preset')}
            >
                <IconStarredFolder />
            </TimelineActionsIcon>
        </div>
    );
}
